module.exports = __webpack_public_path__ + "assets/img/returnBtn-a1198819.png";